import { Typography } from "@bonusx-global/bx-design-system";
import type { PropsWithChildren } from "react";
import type { AiResponseHeaderTextProps } from "./ai-response-markdown-header-text.interface";

function AiResponseHeaderText({ variant, children }: PropsWithChildren<AiResponseHeaderTextProps>): JSX.Element {
  const isCurrentVariantTooBig = variant === "h4" || variant === "h3" || variant === "h2" || variant === "h1";

  if (isCurrentVariantTooBig) {
    variant = "h5";
  }

  return <Typography variant={variant}>{children}</Typography>;
}

export default AiResponseHeaderText;
